<template>
  <div class="comMap">
    <v-map></v-map>
    <!-- 气象切换 -->
    <v-MapSwitch
      v-if="
        $route.path != '/index/runcontrol' &&
        $route.path != '/index/alarmInfo' &&
        $route.path != '/index/dataPlayback'
      "
    ></v-MapSwitch>
    <!-- 气象渐变图例 -->
    <v-MeteoLegendTable></v-MeteoLegendTable>
    <!-- 高度控件 -->
    <v-AltitudeControll></v-AltitudeControll>
    <!-- 时间控件 -->
    <v-TimeControll></v-TimeControll>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.comMap {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>